export default "__VITE_ASSET__6xn8ZSFT__"